"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactHelmet = require("react-helmet");

var _peractoUi = require("@peracto/peracto-ui");

var _peractoConfig = require("@peracto/peracto-config");

var _client = require("@peracto/client");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var FormSubmissionsList = function FormSubmissionsList() {
  var _useClient = (0, _client.useClient)(),
      client = _useClient.client;

  var config = (0, _peractoConfig.useConfig)();
  var formatDate = config.get('user_format_date', config.get('format_date')); // The 'selectable' property is used to define if the
  // column is available in the 'manage columns' dropdown

  var columns = (0, _react.useMemo)(function () {
    return [{
      id: 'selection',
      Header: function Header(_ref) {
        var getToggleAllRowsSelectedProps = _ref.getToggleAllRowsSelectedProps;
        return /*#__PURE__*/_react["default"].createElement(_peractoUi.StyledCheckbox, getToggleAllRowsSelectedProps());
      },
      Cell: function Cell(_ref2) {
        var row = _ref2.row;
        return /*#__PURE__*/_react["default"].createElement(_peractoUi.StyledCheckbox, _extends({}, row.getToggleRowSelectedProps(), {
          "data-testid": "row-".concat(row.index, "-checkbox")
        }));
      },
      selectable: false
    }, {
      Header: 'Name',
      accessor: function accessor(row) {
        return row.form.label;
      },
      id: 'form.label',
      sortType: 'basic',
      Filter: function Filter(props) {
        return /*#__PURE__*/_react["default"].createElement(_peractoUi.TextFilter, _extends({
          label: "Label"
        }, props));
      },
      Cell: function Cell(row) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          to: "".concat(window.location.pathname, "/").concat(row.row.original.originId || row.row.original.id)
        }, row.cell.value);
      },
      selectable: false
    }, {
      Header: 'Date Submitted',
      accessor: 'submittedAt',
      sortType: 'basic',
      Filter: function Filter(props) {
        return /*#__PURE__*/_react["default"].createElement(_peractoUi.DateRangeFilter, _extends({
          label: "Date Submitted"
        }, props));
      },
      Cell: function Cell(_ref3) {
        var value = _ref3.cell.value;
        return value ? /*#__PURE__*/_react["default"].createElement(_peractoUi.TimeAgo, {
          title: formatDate(new Date(value)),
          date: value
        }) : '-';
      },
      selectable: false
    }];
  });

  var onFetchData = function onFetchData(options) {
    return client(_client.GET_LIST, 'form-submissions', options);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("title", null, "Form Submissions | Peracto")), /*#__PURE__*/_react["default"].createElement(_peractoUi.Heading, {
    name: "Form Submissions"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "card card--transparent"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.HydraTable, {
    columns: columns,
    onFetchData: onFetchData
  }))))));
};

var _default = FormSubmissionsList;
exports["default"] = _default;